import React from 'react'
import Heading from "./Heading"
import { Link } from "gatsby"

export default function infoblock({heading}) {
    return (
        <section className="bg-theme my-5 py-4">
        
            <div className="container">
                <Heading title={heading}/>
                <div className="row">
                    <div className="col-10 col-sm-8 mx-auto text-center">
                        <p className="lead text-dark mb-4">
                        Svayuktya is a Sanskrit language word which means ‘naturally originated’. We have absolutely dedicated us to natural and organic ingredients to prepare handmade skincare products. We take care of your skin as well as environment so, we don’t use SLS, SLES, Parabens, Phthalates, mineral oils, artificial fragrance, mineral oils and other harsh harmful chemicals. Our key aim is to provide you eco friendly skincare range. Our products are blended with herbal extracts, natural powders and good quality of essential oils and are prepared freshly on orders. We use minimal amount of preservatives so the shelf life is no longer as other brands. All products are prepared in small batches with love. We try our best to provide superior quality under budget. Our packaging is quite simple but we don’t compromise with the quality of products. We also customize the products on demand of our customers.                        </p>
                        <Link to="/about/" >
                            <button className = "btn btn-warning btn-lb">{heading}</button>
                        </Link>
                    </div>
                </div>
            </div>
        
        </section>
    )
}
